import { Cart, Gift } from '@/app/shared/interface/cart.interface';
import { UserWallet } from '@/app/shared/interface/user.interface';
import { GiftService } from '@/app/shared/services/gift.service';
import { WalletService } from '@/app/shared/services/wallet.service';
import { Component, HostListener, Input, ViewChild } from '@angular/core';
import { GiftDetailComponent } from '../gift-detail/gift-detail.component';
import { CommonService } from '@/app/shared/services/common.service';
import { CartService } from '@/app/shared/services/cart.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-exchanged-gift',
  templateUrl: './exchanged-gift.component.html',
  styleUrl: './exchanged-gift.component.scss'
})
export class ExchangedGiftComponent {

  @ViewChild('giftDetail', { static: false }) giftDetail: GiftDetailComponent;

  @Input() gift: Gift;

  constructor(
    private giftService: GiftService,
    private cartService: CartService,
    private toastService: ToastrService,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    this.commonService.getCart.subscribe(async cart => {
      if (cart) {
        const foundInCart = cart.giftItems.find((item: any) => item.giftId === this.gift.giftId);
        this.gift.quantity = foundInCart ? foundInCart.exchangedQuantity : 0;
      }
      else {
        this.gift.quantity = 0;
      }
    });
  }

  updateGiftCart(gift: Gift, quantity: number) {
    const body: any = {
      giftId: gift.giftId,
      quantity: quantity,
      recordId: gift.recordId
    }
    this.giftService.updateGiftCart(body).subscribe({
      next: (res: any) => {
        if (res && res.data) {
          // this.giftService.refreshExchangedGifts();
          this.cartService.refreshCart();
          this.toastService.success(res.message);
        }
      },
      error: (err: any) => {
        console.error('Có lỗi xảy ra, vui lòng thử lại sau', err);
      }
    });
  }

  openGiftDetail() {
    this.giftDetail.openModal();
  }
}
